<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper kingOrGovernor" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal small kingOrGovernor" style="top: 0;">
				<div class="modalContent" ng-style="{minHeight: w.getOverlayHeightWithPadding(-10) || 'none'}">
					<div class="functionPanel">
						<a @click="onModalClose(close)" @mouseover="cancelHover = true" @mouseleave="cancelHover = false" class="closeWindow clickable" play-on-click="7">
							<i :class="['closeWindow', {action_cancel_small_flat_black: !cancelHover, action_cancel_small_flat_green: cancelHover}]"></i>
						</a>
					</div>
					<div class="contentHeader">
						<h2 ng-if="!w.contentHeaderText" ng-class="::{static: w.params.modalParams.staticPosition}" class="msAntiScroll">
							<span translate="" data="" options="KingOrGovernor.Title"><span>Желаешь стать королем или губернатором?</span></span>
						</h2>
						<!-- ngIf: w.contentHeaderText -->
					</div>
					<div ng-controller="kingOrGovernorCtrl" class="contentBody" ng-init="iconMap={'king':['roleSelect_experienced','roleSelect_defense','unit_treasure','roleSelect_commitment'],'governor':['roleSelect_everyone','unit_stolenGoods','roleSelect_strategy','roleSelect_vacation']}">
						<div class="header tutorial_kingOrGovernor_illustration"></div>
						<div class="role governor" ng-repeat="role in ['governor', 'king']">
							<div class="headerContainer">
								<div class="beginnersProtection">
									<span translate="" options="governor" data="days:3" class="days"><span>3 дн.</span></span>
									<div class="horizontalLine"></div>
									<span translate=""><span>Защита новичка</span></span>
								</div>
							</div>
							<div class="contentBox">
								<h6 class="contentBoxHeader headerWithArrowEndings" ng-class="::{glorious: role == 'king'}">
									<div class="content">
										<span translate="" options="governor"><span>Губернатор</span></span>
									</div>
								</h6>
								<div class="contentBoxBody">
									<div class="feature" ng-repeat="line in []|range:1:3" tooltip="" tooltip-translate="KingOrGovernor.Feature.Tooltip_governor_1">
										<i class="unit_stolenGoods_medium_illu"></i>
										<div class="description" translate="" options="governor,1"><span>Совершай набеги на логова разбойников и добывай сундуки с ценностями.</span></div>
									</div>
									<div class="feature" ng-repeat="line in []|range:1:3" tooltip="" tooltip-translate="KingOrGovernor.Feature.Tooltip_governor_2">
										<i class="roleSelect_strategy_medium_illu"></i>
										<div class="description" translate="" options="governor,2"><span>Свободно выбирай стратегию</span></div>
									</div>
									<div class="feature" ng-repeat="line in []|range:1:3" tooltip="" tooltip-translate="KingOrGovernor.Feature.Tooltip_governor_3">
										<i class="roleSelect_vacation_medium_illu"></i>
										<div class="description" translate="" options="governor,3"><span>Если тебе необходим перерыв в игре, ты можешь использовать режим отпуска</span></div>
									</div>
									<div class="summary" tooltip="" tooltip-translate="KingOrGovernor.Feature.Tooltip.Recommendation_governor">
										<i class="roleSelect_everyone_medium_illu"></i>
										<div translate="" options="governor" class="description"><span>Подходит для всех игроков</span></div>
									</div>
								</div>
								<div ng-if="::role == 'governor'" class="buttonHighlight roleSelect_buttonBackground_layout"></div>
								<button @click="governorSelected = true" clickable="selectRole(role)" ng-class="{disabled: role == 'king' && !kingRegistrationOpened}" class="clickable">
									<div class="content">
										<span class="innerText">Играть губернатором</span>
										<div class="animationOverlay"></div>
										<i class="checkmark action_check_small_flat_white"></i>
										<i class="checkmark action_check_small_flat_black"></i>
										<i class="checkmark action_check_small_flat_red"></i>
									</div>
								</button>
								<!-- ngIf: role == 'king' && !kingRegistrationOpened -->
							</div>
						</div>
						<div class="role king" ng-repeat="role in ['governor', 'king']">
							<div class="headerContainer">
								<div class="beginnersProtection">
									<span translate="" options="king" data="days:3" class="days"><span>3 дн.</span></span>
									<div class="horizontalLine"></div>
									<span translate=""><span>Защита новичка</span></span>
								</div>
							</div>
							<div class="contentBox">
								<h6 class="contentBoxHeader headerWithArrowEndings glorious" ng-class="::{glorious: role == 'king'}">
									<div class="content">
										<span translate="" options="king"><span>Король</span></span>
									</div>
								</h6>
								<div class="contentBoxBody">
									<div class="feature" ng-repeat="line in []|range:1:3" tooltip="" tooltip-translate="KingOrGovernor.Feature.Tooltip_king_1">
										<i class="roleSelect_defense_medium_illu"></i>
										<div class="description" translate="" options="king,1"><span>Защищай своих губернаторов от атак и получай с них дань.</span></div>
									</div>
									<div class="feature" ng-repeat="line in []|range:1:3" tooltip="" tooltip-translate="KingOrGovernor.Feature.Tooltip_king_2">
										<i class="unit_treasure_medium_illu"></i>
										<div class="description" translate="" options="king,2"><span>Собирай сокровища и расширяй свою империю.</span></div>
									</div>
									<div class="feature" ng-repeat="line in []|range:1:3" tooltip="" tooltip-translate="KingOrGovernor.Feature.Tooltip_king_3">
										<i class="roleSelect_commitment_medium_illu"></i>
										<div class="description" translate="" options="king,3"><span>Обязательства</span></div>
									</div>
									<div class="summary" tooltip="" tooltip-translate="KingOrGovernor.Feature.Tooltip.Recommendation_king">
										<i class="roleSelect_experienced_medium_illu"></i>
										<div translate="" options="king" class="description"><span>Для опытных и активных игроков</span></div>
									</div>
								</div>
								<button @click="kingSelected = true" clickable="selectRole(role)" ng-class="{disabled: role == 'king' && !kingRegistrationOpened}" class="clickable">
									<div class="content">
										<span class="innerText">Играть королем</span>
										<div class="animationOverlay"></div>
										<i class="checkmark action_check_small_flat_white"></i>
										<i class="checkmark action_check_small_flat_black"></i>
										<i class="checkmark action_check_small_flat_red"></i>
									</div>
								</button>
								<!-- ngIf: role == 'king' && !kingRegistrationOpened -->
							</div>
						</div>
					</div>
					<div class="window-overlay" name="smallOverlay">
						
						<!--стать губернатором-->
						<div v-if="governorSelected" ng-if="overlayController" class="windowOverlay" id="kingOrGovernorSelected" ng-controller="overlayController">
							<div class="darkener clickable" clickable="closeOverlay()"></div>
							<div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="712">
								<div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
									<div class="inWindowPopupHeader">
										<h4 translate="" options="KingOrGovernor.Selected_governor" ng-if="overlayConfig['inWindowPopupTitle'] != ''"><span>Стать </span><strong>губернатором</strong><span>.</span></h4>
										<h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4>
										<a class="closeOverlay clickable" clickable="closeOverlay()" translate="" @click="governorSelected = false"><span>Закрыть</span></a>
									</div>
									<div class="inWindowPopupContent">
										<div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']">
											<div class="kingOrGovernorSelected">
												<div class="role governor">
													<div class="headerContainer tutorial_governor_illustration">
														<div class="beginnersProtection">
															<span translate="" options="governor" data="days:3" class="days"><span>3 дн.</span></span>
															<div class="horizontalLine"></div>
															<span translate=""><span>Защита новичка</span></span>
														</div>
													</div>
													<h6 class="contentBoxHeader headerWithArrowEndings" ng-class="{glorious: role == 'king'}">
														<div class="content">
															<span translate=""><span>Решение</span></span>
														</div>
													</h6>
													<strong translate="" options="governor"><span>Стань губернатором под защитой короля!</span></strong>
													<div translate="" options="governor"><span>Хороший король всегда поддержит тебя и даст совет, если требуется.</span></div>
													<div class="buttonFooter">
														<button clickable="acceptRole();" class="clickable" @click="onModalClose(close)">
															<div class="content">
																<span class="innerText">Стать губернатором</span>
																<div class="animationOverlay"></div>
																<i class="checkmark action_check_small_flat_white"></i>
																<i class="checkmark action_check_small_flat_black"></i>
																<i class="checkmark action_check_small_flat_red"></i>
															</div>
														</button>
														<button class="cancel clickable" clickable="closeOverlay();" @click="governorSelected = false">
															<div class="content">
																<span class="innerText">Нет, спасибо</span>
																<div class="animationOverlay"></div>
																<i class="checkmark action_check_small_flat_white"></i>
																<i class="checkmark action_check_small_flat_black"></i>
																<i class="checkmark action_check_small_flat_red"></i>
															</div>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						
						<!--стать королем-->
						<div v-if="kingSelected" ng-if="overlayController" class="windowOverlay" id="kingOrGovernorSelected" ng-controller="overlayController">
							<div class="darkener clickable" clickable="closeOverlay()"></div>
							<div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="712">
								<div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
									<div class="inWindowPopupHeader">
										<h4 translate="" options="KingOrGovernor.Selected_king" ng-if="overlayConfig['inWindowPopupTitle'] != ''"><span>Стать </span><strong>королем</strong><span>.</span></h4>
										<h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4>
										<a class="closeOverlay clickable" clickable="closeOverlay()" translate="" @click="kingSelected = false"><span>Закрыть</span></a>
									</div>
									<div class="inWindowPopupContent">
										<div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']">
											<div class="kingOrGovernorSelected">
												<div class="role king">
													<div class="headerContainer tutorial_king_illustration">
														<div class="beginnersProtection">
															<span translate="" options="king" data="days:3" class="days"><span>3 дн.</span></span>
															<div class="horizontalLine"></div>
															<span translate=""><span>Защита новичка</span></span>
														</div>
													</div>
													<h6 class="contentBoxHeader headerWithArrowEndings glorious" ng-class="{glorious: role == 'king'}">
														<div class="content">
															<span translate=""><span>Решение</span></span>
														</div>
													</h6>
													<strong translate="" options="king"><span>Защищай своих губернаторов в роли короля и расширяй империю!</span></strong>
													<div translate="" options="king"><span>Если ты сможешь направлять и оберегать своих губернаторов, они станут твоими верными последователями, и твое королевство будет процветать.</span></div>
													<div class="buttonFooter">
														<button clickable="acceptRole();" class="clickable" @click="onModalClose(close)">
															<div class="content">
																<span class="innerText">Возложить корону</span>
																<div class="animationOverlay"></div>
																<i class="checkmark action_check_small_flat_white"></i>
																<i class="checkmark action_check_small_flat_black"></i>
																<i class="checkmark action_check_small_flat_red"></i>
															</div>
														</button>
														<button class="cancel clickable" clickable="closeOverlay();" @click="kingSelected = false">
															<div class="content">
																<span class="innerText">Нет, спасибо</span>
																<div class="animationOverlay"></div>
																<i class="checkmark action_check_small_flat_white"></i>
																<i class="checkmark action_check_small_flat_black"></i>
																<i class="checkmark action_check_small_flat_red"></i>
															</div>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						
					</div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
		
		governorSelected: false,
		kingSelected: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>